// extracted by mini-css-extract-plugin
module.exports = {"container":"tabs_container__1ngPP","tabs":"tabs_tabs__1mbt4"};